module.exports = __webpack_public_path__ + "static/media/stoofvlees.4969e91d.jpg";